import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/administration/account/')({
  beforeLoad: () => { throw redirect({ to: '/administration/account/account-settings' }); },
});
